export default __webpack_public_path__ + "static/media/slack.6cd33ad1.svg";